import { useState } from 'react';
import Reveal from '../../common/Reveal';
import backgroundImage from "../../../assets/images/onlineclass.svg";
import onlineclass from "../../../assets/images/onlineclasstext.svg";
import arrow from "../../../assets/images/east.svg";

function LiveClassesSection() {
  const [activeSlide, setActiveSlide] = useState(0);
  const totalSlides = 3;

  return (
    <section className="max-w-7xl mx-auto px-4 py-6 sm:px-6 sm:py-7 lg:px-8">

      <div
        className="relative mx-auto min-h-[280px] w-full max-w-7xl overflow-hidden rounded-3xl bg-cover bg-center bg-no-repeat px-4 py-16 sm:px-6 sm:py-20 lg:min-h-[340px] lg:px-8 xl:h-[394px] xl:py-[114px]"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute top-6 left-1/2 -translate-x-1/2">
          <Reveal variant="down">
            <img
              src={onlineclass}
              alt="Online Class"
              className="h-9 w-auto"
            />
          </Reveal>
        </div>
        <div className="mx-auto max-w-4xl text-center">
          <Reveal variant="up" delay={80}>
            <h2 className="mx-auto mt-4 max-w-xl text-2xl font-bold text-white sm:text-3xl lg:text-4xl xl:text-[40px]">
              Expert Instructor Live Classes Here !
            </h2>
          </Reveal>
          <Reveal variant="up" delay={160}>
            <button
              type="button"
              className="mt-14 inline-flex items-center gap-2 rounded-full bg-white px-6 py-2 text-[16px] font-medium uppercase text-[#1B1B1B]"
            >
              JOIN COURSES

              <img
                src={arrow}
                alt="arrow"
                className="h-4 w-4"
              />
            </button>
          </Reveal>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-center gap-2">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setActiveSlide(index)}
            className={`h-2.5 rounded-full transition-all ${activeSlide === index
                ? 'w-8 bg-zinc-900'
                : 'w-2.5 bg-gray-300 hover:bg-gray-400'
              }`}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={activeSlide === index ? 'true' : undefined}
          />
        ))}
      </div>

    </section>
  );
}

export default LiveClassesSection;